// Smoothly tweens a number to a target with easeOutCubic. Returns the
// in-flight value — components re-render at ~60 fps until the target is hit.

import { useEffect, useRef, useState } from "react";

export function useAnimatedNumber(target, duration = 700) {
  const [value, setValue] = useState(target ?? 0);
  const startRef = useRef({ from: target ?? 0, started: 0, target: target ?? 0 });

  useEffect(() => {
    if (target == null) return;
    let raf;
    const from = value;
    const to = target;
    if (from === to) return;
    startRef.current = { from, target: to, started: 0 };

    const step = (t) => {
      if (!startRef.current.started) startRef.current.started = t;
      const elapsed = Math.min(1, (t - startRef.current.started) / duration);
      const eased = 1 - Math.pow(1 - elapsed, 3);
      setValue(from + (to - from) * eased);
      if (elapsed < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => raf && cancelAnimationFrame(raf);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target, duration]);

  return value;
}
